import { css } from '@emotion/core'
import React from 'react'
import PropTypes from 'prop-types'
import { NoticeLoading } from '@fs/zion-icon'
import { Paragraph } from '@fs/zion-ui'
import ActivityCover, { hasActivityCover } from './ActivityCover'

const PageLoadingIndicator = ({ announce = false, constrain, label = '', ...noticeProps }) => {
  if (!constrain && hasActivityCover()) {
    return <ActivityCover />
  }

  const statusLabel = label || 'Loading...'
  const cssLoading = css`
    width: ${constrain ? '100%' : '100vw'};
    height: ${constrain ? '30vh' : '100vh'};
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  `
  return (
    <div
      css={cssLoading}
      data-testid="page-loading-indicator"
      role={announce ? 'status' : undefined}
      aria-label={announce ? statusLabel : undefined}
      aria-live={announce ? 'polite' : undefined}
      aria-atomic={announce ? 'true' : undefined}
      aria-busy={announce ? 'true' : undefined}
      data-page-loading-indicator
    >
      <Paragraph>{label}</Paragraph>
      <NoticeLoading size="lg" {...noticeProps} />
    </div>
  )
}

PageLoadingIndicator.propTypes = {
  // Opt-in: callers that are the only thing on screen set this so the wait is announced. Left off
  // by default so the many existing call sites keep rendering no live region, as they always have.
  announce: PropTypes.bool,
  constrain: PropTypes.bool,
  label: PropTypes.string,
}

export default PageLoadingIndicator
